var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{flex_box:!_vm.isMobile},attrs:{"id":"app"}},[_c('div',{class:{app_box:_vm.widthStyle}},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }